export default __webpack_public_path__ + "50c3a7d70807ce02b8a8e4b7a75bd7e8.svg";